import topNav from './ctrl';
import './style.less';

export default function () {
   return {
       template: require('./topNav.html'),
       controller: ['$rootScope', 'ModalService', topNav],
       controllerAs: 'topNav'
   }
}


// WEBPACK FOOTER //
// ./src/app/directives/app-nav/index.js